const normalise = value => String(value || "").trim().toLocaleLowerCase();

const matching = (items, nameField, query) => {
  const needle = normalise(query);
  return (items || []).filter(item => !needle || normalise(item[nameField]).includes(needle));
};

export const componentSearchResults = (query, ingredients = [], prepRecipes = []) => ({
  ingredients: matching(ingredients, "ingredient_name", query),
  prepItems: matching(prepRecipes, "recipe_name", query),
});

export const hasExactComponentMatch = (query, ingredients = [], prepRecipes = []) => {
  const needle = normalise(query);
  if (!needle) return false;
  return [...ingredients, ...prepRecipes].some(item => normalise(item.ingredient_name || item.recipe_name) === needle);
};

export const componentDisplayName = (component, ingredients = [], prepRecipes = []) => {
  if (!component?.component_id) return "";
  if (component.component_type === "prep_recipe") {
    return component.prep_recipe_name || prepRecipes.find(item => String(item.id) === String(component.component_id))?.recipe_name || "Prep Item";
  }
  return component.ingredient_name || ingredients.find(item => String(item.id) === String(component.component_id))?.ingredient_name || "";
};
